import {LOG_OUT} from 'constants/logOut';

export function logOut (history) {
  return {
    type: LOG_OUT,
    context: { history }
  };
}
